/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import TaxPersonalTable02 from "./components/table-2";
import SoftTypography from "components/SoftTypography";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import SoftInput from "components/SoftInput";
import SelectField from "components/SelectField";
import TaxPersonalTable03 from "./components/table-3";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function TaxProperty01() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "01-1/BK-TTS", checked: false },
    { name: "01-2/BK-TTS", checked: false },
    { name: "PL 43/2022/QH15", checked: false, disabled: true },
    { name: "PL 101/2023/QH15", checked: false, disabled: true },
  ]);

  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế đối với hoạt động cho thuê tài sản
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Áp dụng đối với cá nhân có hoạt động cho thuê tài sản trực tiếp khai thuế với cơ
                quan thuế và tổ chức thay cho cá nhân)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 1 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng kê chi tiết cá nhân cho thuê tài sản
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Kèm theo tờ khai 01/TTS Áp dụng đôi với tổ chức khai thay cho cá nhân cho thuê tài
                sản)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable02
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
        {tab === 2 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Phụ lục bảng kê chi tiết cá nhân cho thuê tài sản
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic">
                (Kèm theo tờ khai 01/TTS Áp dụng đôi với tổ chức khai thay cho cá nhân cho thuê tài
                sản)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable03
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    contactAddress,
    contractCode,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    identity,
    organizationName,
    passport,
    phone,
    phone2,
    province,
    taxId2,
    ward,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={field01a.name}
            label={field01a.label}
            value={values.field01a}
            error={errors.field01a && touched.field01a}
            success={values.field01a?.toString().length > 0 && !errors.field01a}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01b.name}
            label={field01b.label}
            error={errors.field01b && touched.field01b}
            success={values.field01b?.toString().length > 0 && !errors.field01b}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={field01c.name}
            label={field01c.label}
            error={errors.field01c && touched.field01c}
            success={values.field01c?.toString().length > 0 && !errors.field01c}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_quy"
            label="[01d] Quý"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_quy", +value)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_nam"
            label="[01d] Năm"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_nam", +value)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01d.name}
            label={field01d.label}
            error={errors.field01d && touched.field01d}
            success={values.field01d?.toString().length > 0 && !errors.field01d}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={contractCode.name}
            label={contractCode.label}
            value={values.contractCode}
            error={errors.contractCode && touched.contractCode}
            success={values.contractCode?.toString().length > 0 && !errors.contractCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={contactAddress.name}
            label={contactAddress.label}
            value={values.contactAddress}
            error={errors.contactAddress && touched.contactAddress}
            success={values.contactAddress?.toString().length > 0 && !errors.contactAddress}
          />
        </Grid>

        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            label={ward.label}
            name={ward.name}
            value={values.ward}
            placeholder={ward.placeholder}
            error={errors.ward && touched.ward}
            success={values.ward.length > 0 && !errors.ward}
          />
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={identity.name}
            label={identity.label}
            value={values.identity}
            error={errors.identity && touched.identity}
            success={values.identity?.toString().length > 0 && !errors.identity}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={passport.name}
            label={passport.label}
            value={values.passport}
            error={errors.passport && touched.passport}
            success={values.passport?.toString().length > 0 && !errors.passport}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              enableTime: false,
            }}
            name={contractDate.name}
            label={contractDate.label}
            error={errors.contractDate && touched.contractD}
            success={values.contractDate?.toString().length > 0 && !errors.taxCalculationPeriod}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationName.name}
            label={organizationName.label}
            value={values.organizationName}
            error={errors.organizationName && touched.organizationName}
            success={values.organizationName?.toString().length > 0 && !errors.organizationName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId2.name}
            label={taxId2.label}
            value={values.taxId2}
            error={errors.taxId2 && touched.taxId2}
            success={values.taxId2?.toString().length > 0 && !errors.taxId2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>

        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone2.name}
            label={phone2.label}
            value={values.phone2}
            error={errors.phone2 && touched.phone2}
            success={values.phone2?.toString().length > 0 && !errors.phone2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax2.name}
            label={fax2.label}
            value={values.fax2}
            error={errors.fax2 && touched.fax2}
            success={values.fax2?.toString().length > 0 && !errors.fax2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email2.name}
            label={email2.label}
            value={values.email2}
            error={errors.email2 && touched.email2}
            success={values.email2?.toString().length > 0 && !errors.email2}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={authDocument.name}
            label={authDocument.label}
            value={values.authDocument}
            error={errors.authDocument && touched.authDocument}
            success={values.authDocument?.toString().length > 0 && !errors.authDocument}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={authDocumentDate.name}
            label={authDocumentDate.label}
            value={values.authDocumentDate}
            error={errors.authDocumentDate && touched.authDocumentDate}
            success={values.authDocumentDate?.toString().length > 0 && !errors.authDocumentDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

function Fields2({ formData, setFieldValue }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,

    checkbox1,
    checkbox2,
    contractCode,
    field01a,
    field01b,
    field01c,
    field01d,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={field01a.name}
            label={field01a.label}
            value={values.field01a}
            error={errors.field01a && touched.field01a}
            success={values.field01a?.toString().length > 0 && !errors.field01a}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01b.name}
            label={field01b.label}
            error={errors.field01b && touched.field01b}
            success={values.field01b?.toString().length > 0 && !errors.field01b}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={field01c.name}
            label={field01c.label}
            error={errors.field01c && touched.field01c}
            success={values.field01c?.toString().length > 0 && !errors.field01c}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_quy"
            label="[01d] Quý"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_quy", +value)}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name="01d_nam"
            label="[01d] Năm"
            type="number"
            onChange={({ target: { value } }) => setFieldValue("01d_nam", +value)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              plugins: [
                new rangePlugin({
                  shorthand: true,
                  theme: "light",
                  dateFormat: "d/m/Y",
                }),
              ],
              enableTime: false,
            }}
            name={field01d.name}
            label={field01d.label}
            error={errors.field01d && touched.field01d}
            success={values.field01d?.toString().length > 0 && !errors.field01d}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={contractCode.name}
            label={contractCode.label}
            value={values.contractCode}
            error={errors.contractCode && touched.contractCode}
            success={values.contractCode?.toString().length > 0 && !errors.contractCode}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
